//  Theme License Validation + Modern Lock Screen (Updated)
(function() {
  'use strict';

  // ────────────────────────────────────────────────
  //  Config & Helpers
  // ────────────────────────────────────────────────

  function getShopDomain() {
    if (window.Shopify?.shop) {
      return window.Shopify.shop;
    }
    
    const hostname = window.location.hostname;
    if (hostname.includes('myshopify.com')) {
      return hostname;
    }
    
    const shopMeta = document.querySelector('meta[name="shopify-shop-domain"]');
    if (shopMeta) {
      return shopMeta.content;
    }
    
    return hostname;
  }

  const CONFIG = {
    shopDomain: getShopDomain(),
    validationUrl: 'https://.gadget.app/api-verify-license',
    retryAttempts: 1,
    retryDelay: 2000
  };

  let validationInProgress = false;
  let validationResult = null;
  let isLocked = false;

  // ────────────────────────────────────────────────
  //  Lock Screen UI (Golden padlock illustration + refined messaging)
  // ────────────────────────────────────────────────

  function lockTheme() {
    if (isLocked) return;
    isLocked = true;

    const overlay = document.createElement('div');
    overlay.id = '-license-overlay';
    overlay.style.cssText = `
      position: fixed;
      inset: 0;
      background: linear-gradient(135deg, #000000 0%, #0f172a 100%);
      z-index: 999999;
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
      padding: 24px;
      color: #e2e8f0;
      box-sizing: border-box;
    `;

    const card = document.createElement('div');
    card.style.cssText = `
      background: #ffffff;
      border-radius: 20px;
      max-width: 640px;
      width: 100%;
      padding: 56px 48px;
      box-shadow: 0 30px 80px rgba(0,0,0,0.7), 0 10px 40px rgba(0,0,0,0.4);
      text-align: center;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 28px;
      position: relative;
      overflow: hidden;
    `;

    // Subtle brand accent bar at top
    const accentBar = document.createElement('div');
    accentBar.style.cssText = `
      position: absolute;
      top: 0; left: 0; right: 0;
      height: 6px;
      background: linear-gradient(to right, #6366f1, #a855f7);
    `;
    card.appendChild(accentBar);

    card.innerHTML = `
      <div style="margin: 0 auto 24px; max-width: 180px;">
        <img 
          src="https://i.ibb.co/VKYjTd3/360-F-702648535-n45rc53-Hzjg9mmk0-Dc-Fzpm-Yi-Wxb-O5-SC6.jpg" 
          alt="Locked - Select a Plan" 
          style="width: 100%; height: auto; display: block;"
        />
      </div>

      <h1 style="
        margin: 0;
        font-size: 40px;
        font-weight: 800;
        color: #0f172a;
        letter-spacing: -0.8px;
        line-height: 1.15;
      ">
        Select a  Plan
      </h1>

      <p style="
        margin: 0;
        font-size: 18px;
        color: #475569;
        line-height: 1.65;
        max-width: 520px;
      ">
        Your access to  AI Store Builder features is paused because no active plan is selected.<br>
        Visit the app page to choose a plan and continue using all premium features.
      </p>

      <div style="display: flex; flex-wrap: wrap; gap: 16px; justify-content: center; margin: 32px 0 12px;">
        <a href="https://apps.shopify.com/" target="_blank" style="
          display: inline-block;
          padding: 18px 52px;
          background: #6366f1;
          color: white;
          font-size: 18px;
          font-weight: 600;
          border-radius: 12px;
          text-decoration: none;
          box-shadow: 0 6px 20px rgba(99, 102, 241, 0.35);
          transition: all 0.22s;
        " onmouseover="this.style.transform='translateY(-2px)';this.style.boxShadow='0 12px 30px rgba(99,102,241,0.45)'"
           onmouseout="this.style.transform='translateY(0)';this.style.boxShadow='0 6px 20px rgba(99,102,241,0.35)'">
          Go to App & Select Plan
        </a>
      </div>

      <p style="margin: 16px 0 0; font-size: 15px; color: #64748b;">
        Need assistance? Contact us at 
        <a href="mailto:help@storebuilder.com" style="color: #6366f1; font-weight: 500; text-decoration: none;">help@storebuilder.com</a>
      </p>

      <div style="margin-top: 40px; opacity: 0.85;">
        <img 
          src="https://i.ibb.co/LdkrPGfB/logo3.png" 
          alt=" AI Store Builder" 
          style="height: 36px; width: auto;"
        />
      </div>
    `;

    // Responsive styles
    const style = document.createElement('style');
    style.textContent = `
      @media (max-width: 640px) {
        #-license-overlay > div {
          padding: 40px 28px !important;
        }
        #-license-overlay h1 {
          font-size: 32px !important;
        }
        #-license-overlay a {
          padding: 16px 40px !important;
          font-size: 17px !important;
          width: 100%;
          text-align: center;
        }
        #-license-overlay img[alt="Locked - Select a Plan"] {
          max-width: 140px !important;
        }
      }
      @media (max-width: 480px) {
        #-license-overlay > div {
          padding: 32px 20px !important;
        }
        #-license-overlay h1 {
          font-size: 28px !important;
        }
      }
    `;
    document.head.appendChild(style);

    overlay.appendChild(card);
    document.body.appendChild(overlay);

    // Prevent scrolling behind overlay
    document.body.style.overflow = 'hidden';
  }

  // ────────────────────────────────────────────────
  //  License Validation Logic (unchanged)
  // ────────────────────────────────────────────────

  function validateLicenseWithRetry(attempt = 0) {
    return fetch(CONFIG.validationUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        shopDomain: CONFIG.shopDomain
      }),
      signal: AbortSignal.timeout(5000)
    })
    .then(response => {
      if (response.status === 200 || response.status === 403) {
        return response.json().then(data => {
          console.log(': Validation response:', data);
          return data;
        });
      }
      throw new Error(`Validation failed: ${response.status}`);
    })
    .catch(error => {
      if (attempt >= CONFIG.retryAttempts - 1) {
        throw error;
      }
      console.log(`: Validation attempt ${attempt + 1} failed, retrying...`, error.message);
      return new Promise(resolve => {
        setTimeout(() => {
          resolve(validateLicenseWithRetry(attempt + 1));
        }, CONFIG.retryDelay);
      });
    });
  }

  function validateLicense() {
    if (validationInProgress) {
      return Promise.resolve(validationResult);
    }

    if (!CONFIG.shopDomain) {
      console.log(': License validation skipped - missing shop domain');
      return Promise.resolve({ isValid: true, reason: 'config_missing' });
    }

    validationInProgress = true;

    return validateLicenseWithRetry()
      .then(data => {
        validationResult = data;
        validationInProgress = false;
        
        if (data.isValid === false) {
          lockTheme();
        }
        
        return data;
      })
      .catch(error => {
        console.warn(': License validation error:', error);
        validationInProgress = false;
        validationResult = { isValid: true, reason: 'validation_error' };
        return validationResult;
      });
  }

  // ────────────────────────────────────────────────
  //  Initialization & Periodic Checks
  // ────────────────────────────────────────────────

  validateLicense();

  setInterval(validateLicense, 30 * 60 * 1000);

  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) {
      validationResult = null;
      validateLicense();
    }
  });

  window.addEventListener('focus', () => {
    validationResult = null;
    validateLicense();
  });

})();